import { LinearProgress } from '@mui/material';
import React from 'react';

export interface MBWPollLinearProgressProps {
  value: number;
}

export function MBWPollLinearProgress(props: MBWPollLinearProgressProps) {
  return (
    <LinearProgress
      color="primary"
      // classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }}
      sx={{
        backgroundColor: '#171921',
        '& .MuiLinearProgress-bar': {
          backgroundColor: '#9DC3E6',
        },
      }}
      style={{ height: 5, width: '100%' }}
      variant="determinate"
      value={props.value}
    />
  );
}
